import React from 'react';
import { User } from 'lucide-react';

interface ArticleAuthorProps {
  name: string;
  avatar: string;
}

const ArticleAuthor: React.FC<ArticleAuthorProps> = ({ name, avatar }) => {
  return (
    <div className="flex items-center mb-8 pb-8 border-b border-gray-200">
      <img 
        src={avatar}
        alt={name}
        className="w-12 h-12 rounded-full mr-4"
      />
      <div>
        <div className="flex items-center text-gray-600">
          <User className="w-4 h-4 mr-1" />
          <span>Par</span>
        </div>
        <span className="font-medium text-gray-900">{name}</span>
      </div>
    </div>
  );
};

export default ArticleAuthor;